'use es6';

import keyMirror from 'react-utils/keyMirror';
export const MON607_BIZ_OBJECTIVE_CATEGORIES = keyMirror({
  branding: null,
  regular: null
});